import type { IntegrationHealth } from "../types/intelligence";

export type IntegrationConnectorId =
  | "google_calendar"
  | "microsoft_calendar"
  | "gmail"
  | "outlook"
  | "linkedin"
  | "document_ai";

export type { IntegrationHealth };

export interface IntegrationAdapter {
  id: IntegrationConnectorId;
  pullSignals: (opportunityId: string) => Promise<string[]>;
}

export const DEFAULT_INTEGRATION_HEALTH: IntegrationHealth[] = [
  {
    id: "gmail",
    label: "Gmail",
    status: "disconnected",
    lastSyncAt: "",
    capabilities: ["thread_ingest", "follow_up_detection"],
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    status: "disconnected",
    lastSyncAt: "",
    capabilities: ["profile_sync", "recruiter_dm_ingest"],
  },
  {
    id: "google_calendar",
    label: "Google Calendar",
    status: "disconnected",
    lastSyncAt: "",
    capabilities: ["interview_timeline", "deadline_alerts"],
  },
  {
    id: "document_ai",
    label: "Document AI",
    status: "degraded",
    lastSyncAt: "",
    capabilities: ["ocr", "field_extraction"],
  },
];
